module.exports = __webpack_public_path__ + "img/stock4.f861c742.png";